/* Goat Hobbies · comportamiento de los componentes en Shopify (Online Store 2.0).
   Mismas piezas que la capa de Lightspeed; aquí los datos vienen de Liquid y de las APIs de Shopify. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Parts finder: marca → modelo → tipo
  document.querySelectorAll('[data-goat-finder]').forEach(function (f) {
    var datos = JSON.parse(f.querySelector('script[type="application/json"]').textContent || '[]');
    var marcas = datos.map(function (d) { return d.marca; }).filter(function (m, i, a) { return m && a.indexOf(m) === i; });
    f.marca.innerHTML = marcas.map(function (m) { return '<option>' + esc(m) + '</option>'; }).join('');
    function modelos() {
      f.modelo.innerHTML = datos.filter(function (d) { return d.marca === f.marca.value; })
        .map(function (d, i) { return '<option value="' + datos.indexOf(d) + '">' + esc(d.modelo) + '</option>'; }).join('');
    }
    f.marca.addEventListener('change', modelos); modelos();
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = datos[f.modelo.value], tipo = f.tipo.value;
      if (!d) return;
      location.href = d.url
        ? d.url + (tipo ? '?filter.p.tag=' + encodeURIComponent(tipo) : '')
        : f.dataset.search + '?type=product&q=' + encodeURIComponent([d.modelo, tipo].filter(Boolean).join(' '));
    });
  });

  // Get it today: se vuelve a pedir al cambiar de variante
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    var caja = document.querySelector('goat-getit');
    if (!form || !caja) return;
    setTimeout(function () {
      var id = (form.querySelector('[name="id"]') || {}).value;
      if (!id) return;
      fetch(caja.dataset.url + '?variant=' + id + '&section_id=goat-get-it-today')
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var nuevo = new DOMParser().parseFromString(t, 'text/html').querySelector('goat-getit');
          if (nuevo) caja.innerHTML = nuevo.innerHTML;
        });
    }, 50);
  });

  // To run it, you'll need: complementarios de Search & Discovery + añadir los marcados
  document.querySelectorAll('[data-goat-needs]').forEach(function (hueco) {
    fetch(root + 'recommendations/products?product_id=' + hueco.dataset.productId + '&limit=4&intent=complementary&section_id=goat-needs')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var sec = new DOMParser().parseFromString(t, 'text/html').querySelector('.goat-needs');
        if (!sec) return;
        hueco.replaceWith(sec);
        var btn = sec.querySelector('[data-goat-add]'), msg = sec.querySelector('.goat-needs__msg');
        btn.addEventListener('click', function () {
          var items = [].slice.call(sec.querySelectorAll('input:checked')).map(function (i) { return { id: +i.value, quantity: 1 }; });
          if (!items.length) return;
          btn.disabled = true;
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function () {
              var d = sec.dataset, a = document.createElement('a');
              msg.textContent = (items.length > 1 ? d.addedOther.replace('[n]', items.length) : d.addedOne) + ' ';
              a.href = root + 'cart'; a.textContent = d.viewCart; msg.appendChild(a);
              contarCarrito();
            })
            .catch(function () { msg.textContent = sec.dataset.error; })
            .then(function () { btn.disabled = false; });
        });
      });
  });

  // Contador del carrito del encabezado Goat: el número sale de Liquid al cargar la página, así que se pide de nuevo
  // a /cart.js cuando el tema avisa de un cambio (evento cart:update de Horizon: añadir, quitar o cambiar cantidad),
  // tras el «añadir todo» de arriba y al volver con el botón Atrás (la página puede venir de la caché del navegador).
  function contarCarrito() {
    var enlaces = document.querySelectorAll('[data-goat-cart]');
    if (!enlaces.length) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        enlaces.forEach(function (a) {
          var n = a.querySelector('.count');
          if (n) n.textContent = c.item_count;
          if (a.dataset.label) a.setAttribute('aria-label', a.dataset.label.replace('[n]', c.item_count));
        });
      })
      .catch(function () {});
  }
  document.addEventListener('cart:update', contarCarrito);
  window.addEventListener('pageshow', function (e) { if (e.persisted) contarCarrito(); });

  // Zoom de la ficha (Horizon .dialog-zoomed-gallery): cada foto entra entera en la pantalla.
  // En escritorio un clic la amplía a todo el ancho donde se pulsó y otro clic la devuelve; se cierra con la X o Esc.
  // En el móvil se deja el pellizco y el doble toque de Horizon (drag-zoom-wrapper).
  var escritorio = window.matchMedia('(min-width: 750px) and (pointer: fine)');
  window.addEventListener('click', function (e) {
    if (!escritorio.matches) return;
    var li = e.target.closest && e.target.closest('.dialog-zoomed-gallery > li.product-media-container--image');
    if (!li) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var dlg = li.closest('dialog');
    var r = li.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    var ampliar = !li.classList.contains('goat-zoom-in');
    dlg.querySelectorAll('.goat-zoom-in').forEach(function (x) { x.classList.remove('goat-zoom-in'); });
    if (ampliar) {
      li.classList.add('goat-zoom-in');
      var img = li.querySelector('img');
      // pide la versión grande de la foto para que no se vea borrosa
      if (img && img.srcset) img.sizes = '200vw';
      var r2 = li.getBoundingClientRect();
      dlg.scrollTop += r2.top + fy * r2.height - e.clientY;
    } else {
      li.scrollIntoView({ block: 'start' });
    }
  }, true);
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('zoom-dialog dialog'))
      e.target.querySelectorAll('.goat-zoom-in').forEach(function (x) { x.classList.remove('goat-zoom-in'); });
  }, true);
})();
